export default function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isTransformer.js
// module id = 319
// module chunks = 1